import Vue from 'vue'
import {} from '@/store/mutation-types'

const app = {
  state: {
    routerName: 'home',
    menuName: '首页'
  },
  mutations: {
    SET_ROUTER (state, routerName) {
      state.routerName = routerName
    },
    SET_MENU_NAME (state, menuName) {
      state.menuName = menuName
    }
  },
  actions: {
    SetRouter ({ commit }, routerName) {
      commit('SET_ROUTER', routerName)
    },
    SetMenuName ({ commit }, menuName) {
      commit('SET_MENU_NAME', menuName)
    }
  }
}

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js